export class ValidationFailed extends Error {
  constructor(private messages: Record<string, string[]>) {
    super();
  }

  public getMessages() {
    return this.messages;
  }
}
